import { Platform } from 'react-native';

export enum PlatformConstants {
  Web = 'web',
  Android = 'android',
  IOS = 'ios',
  Windows = 'windows',
  Mac = 'mac',
  Unknown = 'unknown',
}

export const isWeb: boolean = Platform.OS === PlatformConstants.Web;
export const isAndroid: boolean = Platform.OS === PlatformConstants.Android;
export const isIOS: boolean = Platform.OS === PlatformConstants.IOS;
export const isLocalhost: boolean =
  (isWeb &&
    typeof window !== 'undefined' &&
    window.location?.hostname === 'localhost') ||
  (__DEV__ && !isWeb);

// Check userAgent to differentiate mobile/desktop browsers
const whatOSAmI = (): PlatformConstants => {
  if (isAndroid) {
    return PlatformConstants.Android;
  }
  if (isIOS) {
    return PlatformConstants.IOS;
  }

  // Default value
  let operatingSystem = PlatformConstants.Unknown;

  const userAgent =
    typeof window !== 'undefined' ? window.navigator?.userAgent : null;

  if (userAgent) {
    if (userAgent.includes('Android')) {
      operatingSystem = PlatformConstants.Android;
    } else if (
      userAgent.includes('iPhone') ||
      userAgent.includes('iPad') ||
      userAgent.includes('iPod') ||
      userAgent.includes('iOS')
    ) {
      operatingSystem = PlatformConstants.IOS;
    } else if (userAgent.includes('Mac')) {
      operatingSystem = PlatformConstants.Mac;
    } else if (userAgent.includes('Win')) {
      operatingSystem = PlatformConstants.Windows;
    }
  }

  return operatingSystem;
};

// Simplify to export directly
export const isAndroidBrowser: boolean =
  isWeb && whatOSAmI() === PlatformConstants.Android;
export const isIOSBrowser: boolean =
  isWeb && whatOSAmI() === PlatformConstants.IOS;
export const isMobileBrowser = isAndroidBrowser || isIOSBrowser;
export const isDesktopBrowser = isWeb && !isMobileBrowser;

export const isMobileOS = [
  PlatformConstants.Android,
  PlatformConstants.IOS,
].includes(whatOSAmI());
export const isWebMac = isWeb && [PlatformConstants.Mac].includes(whatOSAmI());
export const isWebWin =
  isWeb && [PlatformConstants.Windows].includes(whatOSAmI());

export const platformVersion = Platform.Version;

export const getPlatformHeaderValue = () => {
  return Platform.OS.toLocaleLowerCase();
};
